
import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp, Save } from "lucide-react";

interface EmailDraftToggleProps {
  showDrafts: boolean;
  draftsCount: number;
  onToggleDrafts: () => void;
}

const EmailDraftToggle: React.FC<EmailDraftToggleProps> = ({
  showDrafts,
  draftsCount,
  onToggleDrafts
}) => {
  return (
    <Button 
      variant="outline"
      size="sm" 
      onClick={onToggleDrafts}
      className="flex items-center gap-2"
    >
      <Save className="h-4 w-4" />
      Drafts ({draftsCount})
      {showDrafts ? (
        <ChevronUp className="h-4 w-4" />
      ) : (
        <ChevronDown className="h-4 w-4" />
      )}
    </Button>
  );
};

export default EmailDraftToggle;
